import { css } from '@emotion/react';

import { useLocale } from 'lib/localeProvider';

import { tabletUp, notLast, mobileOnly } from 'styles/utils';

import { NHS_REDIRECTS, UK_REDIRECTS } from '../../../utils/constants';
import Text from '../Text/Text';

import { getFooterLinks } from './FooterLinks.config';
import FooterLink from './FooterLink';

const footerLinksCss = css`
  ${tabletUp} {
    display: flex;
    flex: 1;
  }
`;

const groupCss = css`
  ${mobileOnly} {
    ${notLast} {
      margin-bottom: 36px;
    }
  }

  ${tabletUp} {
    flex-grow: 0.24;
  }
`;

function FooterLinks() {
  const { localeCode } = useLocale();
  const links = getFooterLinks(localeCode);

  const redirects = localeCode === 'uk' ? UK_REDIRECTS : NHS_REDIRECTS;

  return (
    <div css={footerLinksCss}>
      {links.map(group => (
        <div key={group.label} css={groupCss}>
          <Text fontWeight={500} fontSize={1.6} lineHeight={1.94}>
            {group.label}
          </Text>

          <ul>
            {group.links.map(link => (
              <FooterLink
                key={link.url}
                redirect={redirects.find(item => item.key === link.url)?.value}
                newTab={redirects.find(item => item.key === link.url)?.newTab}
                {...link}
              />
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default FooterLinks;
